import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import Header from 'components/layout/Header';
import MobileNav from 'components/layout/MobileNav';
import Hero from 'components/Hero';
import Menu from 'components/menu/Menu';
import About from 'components/About';
import Location from 'components/Location';
import Footer from 'components/layout/Footer';
import SEO from 'components/SEO';
import CustomizationModal from 'components/modals/CustomizationModal';

import { useNavigation } from 'context/NavigationContext';
import { useContent } from 'context/ContentContext';

const PageSections = styled.main`
  section {
    scroll-margin-top: clamp(7rem, 6vw, 8rem);
  }
`;

const Homepage = ({ deepLink = null }) => {
  const { handleSectionChange = () => {} } = useNavigation() || {};
  const { seo } = useContent() || {};

  return (
    <>
      <SEO
        title={seo?.title}
        description={seo?.description}
        canonical={seo?.canonical}
        /* Deep-link routes (/liquor) serve the homepage verbatim, so letting
           them be indexed separately would be duplicate content competing with
           `/`. The inherited canonical already points at `/`; this keeps them
           out of the index entirely. They are entry points, not landing pages. */
        noindex={Boolean(deepLink)}
      />
      <div>
        <Header />
        <MobileNav />
        <PageSections>
          <Hero onSectionChange={handleSectionChange} />
          <Menu
            deepLinkCategoryId={deepLink?.categoryId ?? null}
            deepLinkCategorySlug={deepLink?.categorySlug ?? null}
          />
          <CustomizationModal />
          <Location />
          <About />
        </PageSections>
        <Footer onSectionChange={handleSectionChange} />
      </div>
    </>
  );
};

Homepage.propTypes = {
  /** Entry from config/menuDeepLinks.js when reached via a route like /liquor. */
  deepLink: PropTypes.shape({
    path: PropTypes.string,
    categoryId: PropTypes.string,
    categorySlug: PropTypes.string,
  }),
};

export default Homepage;
